export default class TransactionHistoryResponse {
    constructor (json) {
        this._transactions = json.transactions
        this.successful = json.responseCode === 'SUCCESS'
        this.moreRecordsAvailable = json.moreRecordsAvailable
    }

    success () {
        return this.successful
    }

    transactions () {
        return this._transactions
    }

    moreAvailable () {
        return this.moreRecordsAvailable
    }
}

// {
//     "responseCode": "SUCCESS",
//     "transactions": [
//     {
//         "referenceId": 2196888217,
//         "transactionDateTime": "2019-03-01 09:03:20",
//         "postDateTime": "2019-03-01 09:03:30",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "AMT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "343097",
//                         "offerDescription": "MarlboroCigarettes_MD",
//                         "offerType": "NPROD",
//                         "rewardType": "AMT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 1,
//                         "prodDesc": "MarlboroCigarettes",
//                         "prodCode": "MarlboroCigarettes"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196888216,
//         "transactionDateTime": "2019-03-01 09:01:19",
//         "postDateTime": "2019-03-01 09:02:07",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "AMT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "343097",
//                         "offerDescription": "MarlboroCigarettes_MD",
//                         "offerType": "NPROD",
//                         "rewardType": "AMT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 1,
//                         "prodDesc": "MarlboroCigarettes",
//                         "prodCode": "MarlboroCigarettes"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196859365,
//         "transactionDateTime": "2019-02-26 15:20:09",
//         "postDateTime": "2019-02-26 15:20:24",
//         "siteName": "Campbell Test",
//         "transactionAmount": 58.82,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342273",
//                         "offerDescription": "Coffee Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "HOT BEV 24OZ LARGE",
//                         "prodCode": "00410000000045"
//                     }
//                 ]
//             },
//             {
//                 "redeemed": 0.05,
//                 "redemptionType": "CPG",
//                 "offers": [
//                     {
//                         "offerId": "343072",
//                         "offerDescription": "Everyday 5 CPG Offer",
//                         "offerType": "EBO",
//                         "rewardType": "CPG",
//                         "rewardUnit": 0,
//                         "rewardAmount": 0.05
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196859336,
//         "transactionDateTime": "2019-02-26 15:15:03",
//         "postDateTime": "2019-02-26 15:15:34",
//         "siteName": "Campbell Test",
//         "transactionAmount": 78.12,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 0.1,
//                 "redemptionType": "CPG",
//                 "offers": [
//                     {
//                         "offerId": "343072",
//                         "offerDescription": "Everyday 5 CPG Offer",
//                         "offerType": "EBO",
//                         "rewardType": "CPG",
//                         "rewardUnit": 0,
//                         "rewardAmount": 0.05
//                     },
//                     {
//                         "offerId": "340998",
//                         "offerDescription": "BellStores Basket Offer ",
//                         "offerType": "NBKT",
//                         "rewardType": "CPG",
//                         "rewardUnit": 0,
//                         "rewardAmount": 0.05
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857986,
//         "transactionDateTime": "2019-02-26 11:11:35",
//         "postDateTime": "2019-02-26 11:11:37",
//         "siteName": "Campbell Test",
//         "transactionAmount": 30.74,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "343434",
//                         "offerDescription": "Buy 3 Save 30%",
//                         "offerType": "NPROD",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 30,
//                         "prodDesc": "Nab Mini Chips Aholy",
//                         "prodCode": "NabMiniCAhoy"
//                     }
//                 ]
//             },
//             {
//                 "redeemed": 0.05,
//                 "redemptionType": "CPG",
//                 "offers": [
//                     {
//                         "offerId": "10",
//                         "offerDescription": "Site Certificarion/Testing",
//                         "offerType": "ADJ",
//                         "rewardType": "CPG",
//                         "rewardUnit": 0,
//                         "rewardAmount": 0.01
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857373,
//         "transactionDateTime": "2019-02-26 11:03:28",
//         "postDateTime": "2019-02-26 11:03:49",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "343434",
//                         "offerDescription": "Buy 3 Save 30%",
//                         "offerType": "NPROD",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 30,
//                         "prodDesc": "Nab Mini Chips Aholy",
//                         "prodCode": "NabMiniCAhoy"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857359,
//         "transactionDateTime": "2019-02-26 11:00:48",
//         "postDateTime": "2019-02-26 11:00:51",
//         "siteName": "Campbell Test",
//         "transactionAmount": 70.54,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342853",
//                         "offerDescription": "Fountain Drink Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "Jumbo 44oz",
//                         "prodCode": "10003"
//                     }
//                 ]
//             },
//             {
//                 "redeemed": 0.15,
//                 "redemptionType": "CPG",
//                 "offers": [
//                     {
//                         "offerId": "340998",
//                         "offerDescription": "BellStores Basket Offer ",
//                         "offerType": "NBKT",
//                         "rewardType": "CPG",
//                         "rewardUnit": 0,
//                         "rewardAmount": 0.05
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857355,
//         "transactionDateTime": "2019-02-26 10:58:21",
//         "postDateTime": "2019-02-26 10:58:38",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857426,
//         "transactionDateTime": "2019-02-26 10:56:32",
//         "postDateTime": "2019-02-26 10:56:35",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342273",
//                         "offerDescription": "Coffee Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "HOT BEV TRAVEL MUG REFILL",
//                         "prodCode": "1166"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857417,
//         "transactionDateTime": "2019-02-26 10:49:51",
//         "postDateTime": "2019-02-26 10:49:54",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857409,
//         "transactionDateTime": "2019-02-26 10:47:11",
//         "postDateTime": "2019-02-26 10:47:14",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857325,
//         "transactionDateTime": "2019-02-26 10:42:27",
//         "postDateTime": "2019-02-26 10:42:57",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342273",
//                         "offerDescription": "Coffee Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "HOT BEV TRAVEL MUG REFILL",
//                         "prodCode": "1166"
//                     }
//                 ]
//             },
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342853",
//                         "offerDescription": "Fountain Drink Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "Medium 24oz",
//                         "prodCode": "10001"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857319,
//         "transactionDateTime": "2019-02-26 10:41:11",
//         "postDateTime": "2019-02-26 10:41:20",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857316,
//         "transactionDateTime": "2019-02-26 10:39:24",
//         "postDateTime": "2019-02-26 10:39:44",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857312,
//         "transactionDateTime": "2019-02-26 10:38:38",
//         "postDateTime": "2019-02-26 10:38:50",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342853",
//                         "offerDescription": "Fountain Drink Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "Medium 24oz",
//                         "prodCode": "10001"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857305,
//         "transactionDateTime": "2019-02-26 10:36:36",
//         "postDateTime": "2019-02-26 10:36:43",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857299,
//         "transactionDateTime": "2019-02-26 10:35:37",
//         "postDateTime": "2019-02-26 10:35:44",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857297,
//         "transactionDateTime": "2019-02-26 10:34:34",
//         "postDateTime": "2019-02-26 10:34:43",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857296,
//         "transactionDateTime": "2019-02-26 10:33:16",
//         "postDateTime": "2019-02-26 10:33:24",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     },
//     {
//         "referenceId": 2196857290,
//         "transactionDateTime": "2019-02-26 10:31:37",
//         "postDateTime": "2019-02-26 10:31:48",
//         "siteName": "Campbell Test",
//         "transactionAmount": 0,
//         "cardNumber": "Alt ID",
//         "transactionType": "Redemption",
//         "sourceType": "",
//         "retailerName": "BellStores",
//         "rewards": [
//             {
//                 "redeemed": 1,
//                 "redemptionType": "PERCNT_OFF",
//                 "offers": [
//                     {
//                         "offerId": "342273",
//                         "offerDescription": "Coffee Club (Buy 5)",
//                         "offerType": "DPC",
//                         "rewardType": "PERCNT_OFF",
//                         "rewardUnit": 1,
//                         "rewardAmount": 100,
//                         "prodDesc": "HOT BEV 24OZ LARGE",
//                         "prodCode": "00410000000045"
//                     }
//                 ]
//             }
//         ],
//         "retailerId": "CR1001",
//         "siteId": "Test"
//     }
// ],
//     "totalCount": 24,
//     "moreRecordsAvailable": true
// }



// WEBPACK FOOTER //
// ./src/models/responses/TransactionHistoryResponse.js